import React from 'react';
import { i18next } from '@yola/ws-sdk';
import getDisabledMoveTargetFolderIds from './get-disabled-move-target-folder-ids';
import buildFoldersNestingLevelMap from './build-folders-nesting-level-map';
import { ROOT_ID, MAX_FOLDER_NESTING_LEVEL } from '../constants/index.js';

const getMoveToFolderTooltip = ({ pageIds = [], folderIds = [], folders, pages }) => {
  const targetIds = [ROOT_ID, ...folders.map((folder) => folder.id)];
  const disabledIds = getDisabledMoveTargetFolderIds({ folderIds, pageIds, folders, pages });

  if (targetIds.some((id) => !disabledIds.has(id))) {
    return null;
  }

  if (!folderIds.length) {
    return i18next.t('No folders to move to yet');
  }

  const nestingLevelMap = buildFoldersNestingLevelMap(folders);
  const isBlockedByNestingLimit = folders.some(
    (folder) => nestingLevelMap[folder.id] >= MAX_FOLDER_NESTING_LEVEL
  );

  if (isBlockedByNestingLimit) {
    return (
      <>
        {i18next.t("Can't move this folder.")}
        <br />
        {i18next.t('Select and move files inside instead')}
      </>
    );
  }

  return i18next.t('No folders to move to yet');
};

export default getMoveToFolderTooltip;
